import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Grid,
  TextField,
  FormControlLabel,
  Switch,
  Dialog,
  DialogContent,
  DialogContentText,
  InputAdornment,
  IconButton,
  Checkbox,
  MenuItem,
  FormControl,
  InputLabel,
  Select,
  Snackbar,
  Typography,
  Alert,
} from "@mui/material";
import { useCardDetailContext } from "../../../CardDetailContext";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ReactComponent as TickIcon } from "../../../../Assets/img/icons/tick-shape.svg";
import { useQuantityContext } from "../../../QuantityContext";
import useNavigationGuard from "./useNavigationGuard";
import { useUserDetailContext } from "../../../UserDetailContext";
import { AltRouteRounded } from "@mui/icons-material";
import FileDragUploadWithContext from "../../../Utilities/FileDragUploadWithContext";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import loaderGif from "../../../../Assets/img/icons/Animation - 1718370478484.gif";
import CloseIcon from "@mui/icons-material/Close";
import {
  getAllCardDetailsReducer,
  getAllCardInfoReducer,
  patchProfessionalCardReducer,
} from "../../../../Redux/Reducers/CardReducer";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { extractDomain, isValidCompanyEmail } from "../../../Utilities/domainUtils.ts";

function AcademyDetails({ handleSuccess, handleFailure }) {
  const apiKey = process.env.REACT_APP_API_KEY;
  const objectId = localStorage.getItem("objectId");
  const headers = {
    "x-api-key": apiKey,
    "Content-Type": "application/json",
    Authorization: `Bearer ${objectId}`,
  };
  const { cardDetails, updateCardDetails } = useCardDetailContext();
  const { userDetails } = useUserDetailContext();
  const [isDialogNewEmail, setisDialogNewEmail] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [initialCardDetails, setInitialCardDetails] = useState({});
  const [loading, setLoading] = useState(false);
  const { setisNavigationBlocked, openSnackbar, handleInfo } =
    useQuantityContext();
  const dispatch = useDispatch();

  const Allcards = useSelector((state) => state?.CardArray?.AllCardDetailsInfo);

  const filteredCardName = Allcards?.filter(
    (card) =>
      card?.card_name?.toLowerCase().trim() ===
      cardDetails?.CardName?.toLowerCase().trim()
  );

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState({
    title: "",
    body: "",
  });

  const [currentEducation, setCurrentEducation] = useState({
    id: "",
    instlogo: { name: "", type: "", data: "" },
    certificatepic: { name: "", type: "", data: "" },
    eduLevel: "",
    universityName: "",
    fieldofStudy: "",
    institute: "",
    degree: "",
    grade: "",
    startYear: "",
    endYear: "",
    isCurrentlyPursuing: false,
    description: "",
    isPublic: true,
    month: "",
    year: "",
    fullName: "",
    studentId: "",
    verifyMethod: "",
    adminEmailId: "",
    studentEmailId: "",
    verifyDoc: { name: "", type: "", data: "" },
    isVerified: false,
  });

  const [domainValidation, setDomainValidation] = useState({
    isValid: true,
    message: "",
    emailDomain: "",
    instituteDomain: "",
  });

  useEffect(() => {
    setInitialCardDetails(cardDetails);
  }, []);

  useEffect(() => {
    setSaveEnable(
      JSON.stringify(initialCardDetails) !== JSON.stringify(cardDetails)
    );
    setisNavigationBlocked(
      JSON.stringify(initialCardDetails) !== JSON.stringify(cardDetails)
    );
  }, [cardDetails, initialCardDetails]);

  const [SaveEnable, setSaveEnable] = useState(false);
  const [verifyDisable, setVerifyDisable] = useState(false);
  const [showCode, setShowCode] = useState(false);
  const [code, setCode] = useState("");
  const [minutes, setMinutes] = useState(1);
  const [seconds, setSeconds] = useState(0);
  const [showCodeError, setShowCodeError] = useState(false);
  const message = "You have some UnSaved Changes. Do u want to leave ?";
  const [cardNameError, setCardNameError] = useState("");
  const [cardNameError2, setCardNameError2] = useState("");
  useNavigationGuard(SaveEnable, setSaveEnable, message);

  // Helper function to get institute domain
  const getInstituteDomain = () => {
    return cardDetails.institute_domain || 
           cardDetails.institute_website || 
           cardDetails.company_website || 
           "";
  };

  // Validate email domain function
  const validateEmailDomain = (email, domain) => {
    if (!email || !email.trim()) {
      return { 
        isValid: false, 
        message: "Email is required",
        emailDomain: "",
        instituteDomain: extractDomain(domain) || ""
      };
    }
    
    if (!domain || !domain.trim()) {
      return { 
        isValid: false, 
        message: "Institute domain is required. Please add institute website first.",
        emailDomain: email.split('@')[1]?.toLowerCase() || "",
        instituteDomain: ""
      };
    }
    
    const extractedDomain = extractDomain(domain);
    if (!extractedDomain) {
      return { 
        isValid: false, 
        message: "Invalid institute domain format",
        emailDomain: email.split('@')[1]?.toLowerCase() || "",
        instituteDomain: domain
      };
    }
    
    const emailDomain = email.split('@')[1]?.toLowerCase() || "";
    const isValid = isValidCompanyEmail(email, extractedDomain);
    
    return {
      isValid,
      message: isValid ? "Valid email domain" : `Entered email domain does not match institute domain (${extractedDomain}) or its subdomains`,
      emailDomain,
      instituteDomain: extractedDomain
    };
  };

  // Update domain validation whenever email or verify method changes
  useEffect(() => {
    if (currentEducation.verifyMethod === "studentEmailId") {
      const validation = validateEmailDomain(
        cardDetails.student_email_id,
        getInstituteDomain()
      );
      setDomainValidation(validation);
      setVerifyDisable(!validation.isValid);
      
      if (!validation.isValid && cardDetails.student_email_id) {
        setCardNameError2(validation.message);
      } else {
        setCardNameError2("");
      }
    } else if (currentEducation.verifyMethod === "adminEmailId") {
      const validation = validateEmailDomain(
        currentEducation.adminEmailId,
        getInstituteDomain()
      );
      setDomainValidation(validation);
      setVerifyDisable(!validation.isValid);
      
      if (!validation.isValid && currentEducation.adminEmailId) {
        setCardNameError(validation.message);
      } else {
        setCardNameError("");
      }
    }
  }, [
    currentEducation.verifyMethod,
    cardDetails.student_email_id,
    currentEducation.adminEmailId,
    cardDetails.institute_domain,
    cardDetails.institute_website,
    cardDetails.company_website
  ]);

  const isEnableVerifyButton = () => {
    let requiredFields = [
      "student_id",
      "student_email_id",
      "student_year",
      "student_ending_year",
    ];

    const isCommonFieldsFilled = requiredFields.every(
      (field) => cardDetails[field]
    );

    if (!isCommonFieldsFilled) return false;

    // Check fields based on the selected verifyMethod
    if (currentEducation.verifyMethod === "studentEmailId") {
      return cardDetails.student_email_id !== "" && domainValidation.isValid;
    } else if (currentEducation.verifyMethod === "adminEmailId") {
      return currentEducation.adminEmailId !== "" && domainValidation.isValid;
    } else if (currentEducation.verifyMethod === "verifyDoc") {
      return (
        currentEducation?.verifyDoc && currentEducation.verifyDoc.data !== ""
      );
    }

    return false;
  };

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  const handleInputChange = (fieldName) => (event) => {
    const newValue = event.target.value;
    updateCardDetails({ [fieldName]: newValue });
  };

  const handlecloseDialog = () => {
    setisDialogNewEmail(false);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (minutes === 0 && seconds === 0) {
        setCode("");
        clearInterval(interval);
      } else {
        if (seconds > 0) {
          setSeconds(seconds - 1);
        } else {
          if (minutes > 0) {
            setMinutes(minutes - 1);
            setSeconds(59);
          }
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds, minutes]);

  const handleCodeChange = (event) => {
    setCode(event.target.value);
    setShowCodeError(false);
  };

  const handleCodeSubmitNewEmail = async () => {
    // Validate email domain before OTP verification
    const validation = validateEmailDomain(
      cardDetails.student_email_id,
      getInstituteDomain()
    );

    if (!validation.isValid) {
      setErrorMessage(validation.message);
      return;
    }

    try {
      axios
        .post(
          `${process.env.REACT_APP_BACKEND_URL}/onboard/twofactor-verify-otp`,
          {
            email: cardDetails.student_email_id,
            otp: code,
          },
          { headers: headers }
        )
        .then(async (response) => {
          setCode("");
          setErrorMessage("");
          setisDialogNewEmail(false);
          updateCardDetails({ ["is_student_verified"]: true });
          handleSuccess("Email Verified Successfully!");
        })
        .catch((error) => {
          setErrorMessage("Incorrect OTP. Please try again.");
          console.error("Failed to verify OTP:", error);
        });
    } catch (error) {
      console.error("Error in domain verification or OTP submission:", error);
    }
  };

  const SendingOTP = async () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const isEmailValid = emailRegex.test(cardDetails.student_email_id);

    if (!isEmailValid) {
      handleInfo("Please enter a valid email address.");
      setMinutes(0);
      setSeconds(60);
      setisDialogNewEmail(false);
      return;
    }

    // Add domain validation before sending OTP
    const validation = validateEmailDomain(
      cardDetails.student_email_id,
      getInstituteDomain()
    );

    if (!validation.isValid) {
      handleInfo(validation.message);
      setMinutes(0);
      setSeconds(60);
      setisDialogNewEmail(false);
      return;
    }

    axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/onboard/twofactor-second-otp`,
        {
          email: cardDetails.student_email_id,
        },
        { headers: headers }
      )
      .then((response) => {
        console.log("OTP sent successfully");
        setMinutes(0);
        setSeconds(60);
        setisDialogNewEmail(true);
      })
      .catch((error) => {
        console.error("Failed to send OTP:", error);
      });
  };

  const handleSave = async (event) => {
    event.preventDefault();

    try {
      const payload = { ...cardDetails };
      delete payload.CardName;

      if (
        cardDetails?.CardType === "Student" ||
        cardDetails?.CardType === "Customize_Student"
      ) {
        const resolvedCardId = isNaN(cardDetails?.card_id)
          ? filteredCardName?.[0]?.id
          : cardDetails?.card_id;

        const response = await dispatch(
          patchProfessionalCardReducer({ id: resolvedCardId, data: payload })
        );
        console.log("RESPONSE IN THE Professional update", response);
        await dispatch(getAllCardDetailsReducer());
        await dispatch(getAllCardInfoReducer());

        setInitialCardDetails(cardDetails);

        handleSuccess();
      }
    } catch (error) {
      console.error("Error submitting card details:", error);
      handleFailure();
    }
  };

  const handleSaveCustom = async () => {
    try {
      const fetchedLogo = response.logo;
      const payload = { ...cardDetails, logo: fetchedLogo };
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/card/personaldata`,
        payload,
        {
          headers: headers,
        }
      );

      console.log("Response from backend:", response.data);
      setInitialCardDetails(cardDetails);
      await dispatch(getAllCardDetailsReducer());
      await dispatch(getAllCardInfoReducer());
      handleSuccess();
    } catch (error) {
      console.error("Error submitting card details:", error);
      handleFailure();
    }
  };

  const handleVerify = async (event) => {
    event.preventDefault();

    if (currentEducation.verifyMethod === "studentEmailId") {
      // Validate student email
      const validation = validateEmailDomain(
        cardDetails.student_email_id,
        getInstituteDomain()
      );

      if (!validation.isValid) {
        setCardNameError2(validation.message);
        return;
      }

      setCardNameError2("");
      await SendingOTP();
      setVerifyDisable(false);
      
    } else if (currentEducation.verifyMethod === "adminEmailId") {
      // Validate admin email
      const validation = validateEmailDomain(
        currentEducation.adminEmailId,
        getInstituteDomain()
      );

      if (!validation.isValid) {
        setCardNameError(validation.message);
        return;
      }

      setCardNameError("");
      
      if (currentEducation.adminEmailId) {
        const formData = new FormData();
        formData.append(
          "studentDetails",
          JSON.stringify({
            selectedOption: "admin_mail",
            name: userDetails?.name || "User",
            student_id: cardDetails?.student_id || "",
            card_name: cardDetails?.CardName,
            card_type: cardDetails?.CardType,
            admin_email: currentEducation.adminEmailId,
          })
        );

        try {
          setLoading(true);
          openSnackbar("Sending E-mail to your Institute Admin", "info", 5000);
          setVerifyDisable(true);
          
          const response = await axios.post(
            `${process.env.REACT_APP_BACKEND_URL}/card/verification-option`,
            formData,
            { headers }
          );

          console.log("Response from backend status:", response.data.status);

          if (response.data.status === "SUCCESS") {
            setLoading(false);
            handleSuccess("Verified message sent Successfully to mail!");
            setVerifyDisable(false);
          } else if (response.data.status === "ERROR") {
            setLoading(false);
            handleFailure("Failed to send the message.");
          }
        } catch (error) {
          console.error("Error verifying details:", error);
          setLoading(false);
          handleFailure("Failed to Verify.");
        }
      }
      setVerifyDisable(false);
    }
  };

  const handleCheckboxChange = (event) => {
    const checked = event.target.checked;
    updateCardDetails({ student_currently_pursuing: checked });
    if (checked) {
      updateCardDetails({ student_ending_year: "Present" });
    } else {
      updateCardDetails({ student_ending_year: "" });
    }
  };

  const handleChangeEducationItems = (fieldName) => (event) => {
    const newValue = event.target.value;
    const updatedField = { [fieldName]: newValue };
    const updatedEducation = { ...currentEducation, ...updatedField };
    updateCurrentEducation(updatedField);
    setVerifyDisable(false);
  };

  const updateCurrentEducation = (updatedField) => {
    setCurrentEducation((prevEducation) => ({
      ...prevEducation,
      ...updatedField,
    }));
  };

  const toggleCodeVisibility = () => {
    setShowCode((prev) => !prev);
  };

  const sendOtpNewEmail = () => {
    SendingOTP();
  };

  const currentYear = new Date().getFullYear();
  const years = Array.from(
    { length: currentYear - 1970 + 1 },
    (_, index) => currentYear - index
  );

  return (
    <>
      <div>
        <div>
          <div style={{ paddingRight: "16px", paddingLeft: "16px" }}>
            <div className="card-edit-info-heading">
              <h5>Academic Details</h5>
              <span>
                Please note that this information won't appear on the card while
                sharing
              </span>
              <p className="text-display-details my-2">
                *Confidential information, share options not available{" "}
              </p>
            </div>

            <div className="my-2 user-details-container">
              <Grid container spacing={2}>
                {/* First Column */}
                <Grid item xs={6}>
                  <Grid container direction="column" spacing={2}>
                    <Grid item>
                      <TextField
                        label="Student ID"
                        fullWidth
                        value={cardDetails?.student_id || ""}
                        onChange={handleInputChange("student_id")}
                        required
                        inputProps={{ maxLength: 18 }}
                      />
                    </Grid>
                    <Grid item>
                      <TextField
                        label="Starting Year"
                        fullWidth
                        value={cardDetails?.student_year || ""}
                        onChange={handleInputChange("student_year")}
                        select
                        required
                      >
                        {(years || []).map((year, index) => (
                          <MenuItem key={index} value={year}>
                            {year}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>

                    <Grid item>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={cardDetails?.student_currently_pursuing}
                            onChange={handleCheckboxChange}
                          />
                        }
                        label="Currently Pursuing"
                      />
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={6}>
                  <Grid container direction="column" spacing={2}>
                    <Grid item>
                      <TextField
                        label="Student Email ID"
                        fullWidth
                        value={
                          cardDetails?.student_email_id ||
                          currentEducation?.EmailId
                        }
                        onChange={handleInputChange("student_email_id")}
                        inputProps={{ maxLength: 48 }}
                      />
                    </Grid>
                    <Grid item>
                      <TextField
                        label="Ending Year"
                        fullWidth
                        value={cardDetails?.student_ending_year || ""}
                        onChange={handleInputChange("student_ending_year")}
                        select
                        required
                        disabled={cardDetails?.student_currently_pursuing}
                      >
                        {(years || []).map((year, index) => (
                          <MenuItem key={index} value={year}>
                            {year}
                          </MenuItem>
                        ))}
                        {cardDetails?.student_currently_pursuing && (
                          <MenuItem key="Present" value="Present">
                            Present
                          </MenuItem>
                        )}
                      </TextField>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={6}>
                  <Grid container direction="column" spacing={2}>
                    <Grid item>
                      <TextField
                        name="verifyMethod"
                        label="Verification Method"
                        onChange={handleChangeEducationItems("verifyMethod")}
                        fullWidth
                        select
                      >
                       {cardDetails?.student_currently_pursuing && <MenuItem value="studentEmailId">
                          My Institute E-mail ID
                        </MenuItem>}
                        <MenuItem value="adminEmailId">
                          My Institute Admin E-mail ID
                        </MenuItem>
                        {/* <MenuItem value="verifyDoc">
                          Upload Verification Document
                        </MenuItem> */}
                      </TextField>
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={12}>
                  <Grid container direction="column" spacing={2}>
                    <Grid item>
                      {currentEducation?.verifyMethod !== "" && (
                        <>
                          {currentEducation?.verifyMethod ===
                            "studentEmailId" && (
                            <>
                              <TextField
                                name="studentId"
                                label="Student Email ID"
                                value={
                                  cardDetails?.student_email_id ||
                                  currentEducation?.EmailId
                                }
                                onChange={handleChangeEducationItems(
                                  "studentEmailId"
                                )}
                                fullWidth
                                helperText={`Entred Email ID and Domsin is not matching`}
                                required
                                inputProps={{ maxLength: 48 }}
                                error={!domainValidation.isValid && !!cardDetails?.student_email_id}
                              />
                              {!domainValidation.isValid && cardDetails?.student_email_id && (
                                <Alert 
                                  severity="error" 
                                  sx={{ mt: 1, mb: 1 }}
                                  icon={<CloseIcon />}
                                >
                                  {domainValidation.message}
                                </Alert>
                              )}
                            </>
                          )}
                          
                          {currentEducation?.verifyMethod ===
                            "adminEmailId" && (
                            <>
                              <TextField
                                name="adminId"
                                label="Admin Email ID"
                                value={currentEducation?.adminEmailId}
                                onChange={handleChangeEducationItems(
                                  "adminEmailId"
                                )}
                                fullWidth
                                helperText={`Email must end with @${domainValidation.instituteDomain || "your-institute-domain"} or a subdomain`}
                                inputProps={{ maxLength: 48 }}
                                error={!domainValidation.isValid && !!currentEducation?.adminEmailId}
                              />
                              {!domainValidation.isValid && currentEducation?.adminEmailId && (
                                <Alert 
                                  severity="error" 
                                  sx={{ mt: 1, mb: 1 }}
                                  icon={<CloseIcon />}
                                >
                                  {domainValidation.message}
                                </Alert>
                              )}
                            </>
                          )}
                          
                          {currentEducation?.verifyMethod === "verifyDoc" && (
                            <FileDragUploadWithContext
                              label="Upload Verification Document"
                              maxSize={5}
                              inputId="verifyEduDoc"
                              contextKey="verifyDoc"
                              context={currentEducation}
                              updateContext={updateCurrentEducation}
                              accept={[
                                "image/jpeg",
                                "image/png",
                                "application/pdf",
                              ]}
                            />
                          )}
                        </>
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <FormControlLabel
                control={<Switch disabled />}
                label="Disabled"
              />
            </div>
          </div>

          <div
            className="save-bottom-container"
            style={{
              display: "flex",
              justifyContent: "space-between",
              backgroundColor: "#0044C614",
              padding: "12px",
              borderRadius: "0 0 8px 8px",
            }}
          >
            {/* Left-aligned Verify button */}
            <div className="save-bottom" style={{ textAlign: "left" }}>
              {cardDetails?.is_student_verified ? (
                <Button
                  variant="contained"
                  className="verify-button success-green"
                  disabled
                >
                  Verified
                </Button>
              ) : (
                <Button
                  variant="contained"
                  sx={{ 
                    backgroundColor: "#0044C6",
                    opacity: !isEnableVerifyButton() ? 0.5 : 1,
                    cursor: !isEnableVerifyButton() ? "not-allowed" : "pointer"
                  }}
                  onClick={!verifyDisable ? handleVerify : undefined}
                  disabled={!isEnableVerifyButton() || verifyDisable}
                >
                  Verify
                </Button>
              )}
            </div>

            {/* Right-aligned Save button */}
            <div className="save-bottom" style={{ textAlign: "right" }}>
              <Button
                variant="contained"
                sx={{ backgroundColor: "#0044C6" }}
                onClick={handleSave}
                disabled={!SaveEnable}
              >
                Save
              </Button>
            </div>
          </div>

          <ToastContainer toastClassName="email-toast-success" />
        </div>
      </div>

      {isDialogNewEmail && (
        <Dialog
          open={isDialogNewEmail}
          aria-labelledby="Enable 2FA (Two-factor Authentication)"
          aria-describedby="alert-dialog-description"
        >
          <DialogContent className="dialogContainer">
            <DialogContentText className="dialogText">
              <div>
                <p className="mt-10 onboard_header_align">
                  Two-factor Authentication
                </p>
                <p className="paragraph-text">Verify your new E-mail ID</p>
                <button
                  type="button"
                  className="lightbox__close"
                  onClick={handlecloseDialog}
                >
                  &times;
                </button>
                <div>
                  <div className="">
                    <div>
                      <TextField
                        type={showCode ? "text" : "password"}
                        value={code}
                        onChange={handleCodeChange}
                        error={showCodeError}
                        helperText={showCodeError ? "Code is required" : ""}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        disabled={minutes === 0 && seconds === 0}
                        className={`text-field-outline input-text d-flex ${
                          showCodeError ? "error-textfield" : ""
                        }`}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment position="end">
                              <IconButton onClick={toggleCodeVisibility}>
                                {showCode ? (
                                  <VisibilityIcon />
                                ) : (
                                  <VisibilityOffIcon />
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </div>

                    {errorMessage ? (
                      <div style={{ color: "red", marginTop: "10px" }}>
                        {errorMessage}
                      </div>
                    ) : (
                      <div style={{ marginTop: "10px" }}></div>
                    )}

                    <div className="justify-content-space-bw-login mt-20">
                      <div className="resent-otp">
                        Remaining Time: {minutes < 10 ? `0${minutes}` : minutes}
                        :{seconds < 10 ? `0${seconds}` : seconds}
                      </div>

                      <div
                        className="next-button-container"
                        style={{ gap: "16px" }}
                      >
                        <button
                          className={`next-btn ${
                            code.trim() === "" ? "disabled" : ""
                          }`}
                          type="submit"
                          onClick={handleCodeSubmitNewEmail}
                          disabled={code.trim() === ""}
                        >
                          Next
                        </button>
                      </div>
                    </div>
                    <div className="resent-otp-design mt-20">
                      Didn't get the mail?{" "}
                      <button
                        className="button-style-height"
                        onClick={sendOtpNewEmail}
                      >
                        RESEND
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </DialogContentText>
          </DialogContent>
        </Dialog>
      )}
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={1000}
        onClose={handleCloseSnackbar}
        message="Verification message sent to the admin"
        action={
          <IconButton
            size="small"
            aria-label="close"
            severity="success"
            onClick={handleCloseSnackbar}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        }
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      />
    </>
  );
}

export default AcademyDetails;